import React from "react"
import ArtworksPage from "../../../../features/pages/ArtworksPage"
import GalleryErrorPage from "../../../../features/pages/GalleryErrorPage"
import galleryApiService from "../../../../services/galleryApiService"

const Artworks = ({
  catalog,
  gallery,
  errorCode,
  filters,
  featuredGalleries,
}) => {
  if (errorCode && errorCode !== 200)
    return (
      <GalleryErrorPage
        status={errorCode}
        gallery={gallery}
        featuredGalleries={featuredGalleries}
      />
    )

  return <ArtworksPage catalog={catalog} gallery={gallery} filters={filters} />
}

export const getServerSideProps = async ({ params }) => {
  const { id } = params

  // If given an ID find the domain and redirect
  const isNumericId = /^\d+$/.test(id)
  if (isNumericId) {
    const response = await galleryApiService
      .gallery(id)
      .catch((err) => err.response)
    if (!response || response.status !== 200) {
      return { notFound: true }
    }
    return {
      redirect: {
        destination: `/galleries/${response.data.domain}/artworks`,
        permanent: true,
      },
    }
  }

  try {
    // Otherwise it is the domain
    const response = await galleryApiService
      .galleryByDomain(id)
      .catch((err) => err.response)

    if (response.data.status === 404) {
      return { notFound: true }
    }

    // If the gallery is not available, get the featured galleries
    let featuredGalleries = null
    if (response.data.status === 403) {
      try {
        const result = await galleryApiService.featured()
        featuredGalleries = result.data
      } catch (error) {
        console.error("Error fetching featured galleries:", error)
        featuredGalleries = []
      }
    }

    let artworksResponse = { data: null }
    let filterResponse = { data: null }
    if (response.data.status !== 403) {
      artworksResponse = await galleryApiService
        .galleryArtworks(response.data.id)
        .catch((err) => err.response)
      filterResponse = await galleryApiService.artworksfilters()
    }

    return {
      props: {
        errorCode: response.data.status,
        gallery: response.data,
        catalog: artworksResponse.data,
        filters: filterResponse.data,
        featuredGalleries: featuredGalleries,
      },
    }
  } catch (e) {
    return { notFound: true }
  }
}

export default Artworks
